const getBannerIndex = (items, banner) => items && items.length && banner ? items.findIndex(item => item === banner) : -1;
export default getBannerIndex;
//# sourceMappingURL=get-banner-index.js.map